import { Button, styled } from '@mui/material'

export const StyledLoginButton = styled(Button)(({ theme }) => ({
  borderRadius: '5px',
  padding: '10px clamp(12px,2vw,20px)',
  display: 'flex',
  margin: '0 auto',
  backgroundColor: 'var(--white)',
  fontWeight: 700,
  color: 'var(--black)',
  // fontSize: 'clamp(12px,2vw,14px)',
  fontSize: 'clamp(10px,1vw,20px)',
  ['&:hover']: {
    backgroundColor: 'var(--background)'
  },
  ['& svg']: {
    marginInlineEnd: '5px',
    height: '20px'
  },
  ['&.dark']: {
    backgroundColor: 'var(--blue)',
    color: 'var(--white)',
    ['&:hover']: {
      backgroundColor: 'var(--dark-blue)'
    }
  },
  [theme.breakpoints.down('md')]: {
    ['&.mobile']: {
      width: '100%',
      fontSize: '16px'
    }
  },
  ['&.header']: {
    margin: '0',
    padding: '10px 10px',
    lineHeight: '1em',
    fontWeight: 400
  }
}))
